import { ReactNode } from 'react';
import { SubAccountListContext, SubAccountListContextValue } from './SubAccountListContext';

type SubAccountListProviderProps = {
  value: SubAccountListContextValue;
  children: ReactNode;
};

// Feature-local, not app-level: the Sub-Account List root builds the value (host props + the list state it
// owns) and mounts this so the feature's internal parts (SubAccountList.Table) read useSubAccountList()
// instead of being handed everything one level at a time. Deliberately not exported from the package barrel —
// the host mounts only the root and passes props.
export default function SubAccountListProvider({ value, children }: SubAccountListProviderProps) {
  return <SubAccountListContext.Provider value={value}>{children}</SubAccountListContext.Provider>;
}
